<template>
  <div class="SMS">
    <ba-header activeModule="Text Messages"></ba-header>
    <div class="u-p4 main-content">
      <h2 class="c-heading__page u-mt4 u-pt2">Text Messages</h2>
      <div>
        <div class="u-mt3">
          <div class="u-mt4">
            <el-form inline>
              <el-form-item label="From" class="line-height-3"><el-date-picker v-model="range.from" type="date" format="MM/dd/yyyy" placeholder="Pick a date"></el-date-picker></el-form-item>
              <el-form-item label="To" class="line-height-3"><el-date-picker  v-model="range.to" type="date" format="MM/dd/yyyy" placeholder="Pick a date"></el-date-picker></el-form-item>
              <el-form-item label="Insured" class="line-height-3">
                <el-select v-model="selectedUserName" filterable>
                  <el-option :selected="selectedUser===user.id"
                             v-for="user in usersList"
                             :label="user.name"
                             :value="user.id"
                             :key="user.id" />
                </el-select>
              </el-form-item>
              <el-form-item><el-button @click="loadPage(1)" icon="el-icon-search">Filter</el-button></el-form-item>
              <el-button v-if="range.from !== '' || range.to !== '' || this.selectedUser !== -1" @click="clearFilter">Clear Filter</el-button>
            </el-form>
          </div>
          <h2 class="u-pt2">Text Message Events</h2>
          <el-table v-loading="loading" class="u-mt3 email-table" :data="items" style="width: 100%" :row-class-name="getStatusClassName">
            <el-table-column prop="user_name" label="Insured"></el-table-column>
            <el-table-column prop="formatted_phone_number" label="Phone Number"></el-table-column>
            <el-table-column v-if="isSuperUser" prop="actual_phone_number" label="Actual Phone Number"></el-table-column>
            <el-table-column label="Event Date/Time">
              <template slot-scope="scope">
                {{ fixedTimestamp(scope.row.sent_at) }}
              </template>
            </el-table-column>
            <el-table-column label="Status" class="proper-case">
              <template slot-scope="scope">
                {{ getStatusText(scope.row.status) }}
              </template>
            </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="u-mt2"><span class="detail-header">Message: </span>{{scope.row.content}}</div>                
              <div class="u-mt2" v-if="scope.row.status_details"><span class="detail-header">Error Details: </span>{{scope.row.status_details}}</div>            
            </template>
          </el-table-column>
        
          </el-table>
          <el-pagination class="u-mt4" :layout="paginationLayout"
                         :total="total" :page-size="perPage"
                         :current-page="page" @current-change="loadPage">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* esli1nt-disable */
import { mapState, mapGetters } from 'vuex'
import axios from 'axios'
import config from '@/config'
import _ from 'lodash'
import * as moment from 'moment'

export default {
  name: 'ba-sms',
  data () {
    return {
      companyId: this.$route.params.companyId,
      range: {
        from: '',
        to: '',
      },
      items: [],
      usersListBriteApps: [],
      selectedUser: -1,
      loading: true,
      total: 0,
      page: 1,
      perPage: 20,
      numPages: 0,
    }
  },
  computed: {
    ...mapState('shared', ['user']),
    ...mapGetters('shared', ['companyById']),
    paginationLayout () {
      let moreThan15Pages = this.numPages > 15

      return moreThan15Pages ? 'prev, pager, next, jumper' : 'prev, pager, next'
    },
    isSuperUser () {
      return ((this.user !== undefined) && (this.user !== null)) ? this.user.is_superuser : false
    },
    usersList () {
      return [{id: -1, name: 'All'}].concat(this.usersListBriteApps)
    },
    selectedUserName: {
      get: function () {
        let user = _.find(this.usersList, user => {
          return user.id === this.selectedUser
        })
        return user.name
      },
      set: function (newValue) {
        this.selectedUser = newValue
      }
    },
  },
  beforeMount () {
    this.loading = true
    this.loadInitial()
  },
  methods: {
    getStatusClassName ({row, rowIndex}) {
      let rowClass = ''
      if (row.status === 'FAILURE') {
        rowClass = 'failed-row'
      }
      return rowClass
    },
    getStatusText (status) {
      return status.charAt(0) + status.substr(1).toLowerCase()
    },
    toggleRow (scope) {
      scope.store.table.toggleRowExpansion(scope.row)
    },
    loadInitial () {
      this.loadPage(1)
    },
    clearFilter () {
      this.range.from = ''
      this.range.to = ''
      this.selectedUser = -1
      return this.loadPage(1)
    },
    fixedTimestamp (timestamp) {
      return moment(new Date(timestamp)).format('MM/DD/YYYY hh:mm:ss A')
    },
    loadPage (page) {
      console.log('loadPage')
      this.loading = true
      this.items = []

      let params = {
        page_size: this.perPage,
        page: page,
        from_date: this.$moment(this.range.from).format('MM-DD-YYYY'),
        to_date: this.$moment(this.range.to).format('MM-DD-YYYY'),
      }
      if (this.selectedUser !== -1) {
        params.user = this.selectedUser
      }

      axios.post(`${config.url}/company/${this.companyId}/sms-events/`, params)
        .then((ret) => {
          this.items = ret.data.data.search_results.items
          this.usersListBriteApps = ret.data.data.users
          this.total = ret.data.data.search_results.total
          this.perPage = ret.data.data.search_results.page_size
          this.page = ret.data.data.search_results.page
          this.numPages = ret.data.data.search_results.num_pages
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>

  .detail-header {
    font-weight: bold;
  }

</style>

